// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HuPpX","maxWidthContainer":"styles_maxWidthContainer__+lfOq","logo":"styles_logo__+wJ7V","text":"styles_text__SJKYK","socials":"styles_socials__MhYvq"};